export default __webpack_public_path__ + "static/media/nutri1.4ddbc1d2.jpg";